const places = [
  {
    name: "Athens",
    lat: 37.98381,
    lng: 23.727539,
    size: 0.2,
    color: "white",
  },
  {
    name: "Berlin",
    lat: 52.520008,
    lng: 13.404954,
    size: 0.2,
    color: "white",
  },
  {
    name: "Cairo",
    lat: 30.033333,
    lng: 31.233334,
    size: 0.2,
    color: "white",
  },
  {
    name: "Honolulu",
    lat: 21.315603,
    lng: -157.858093,
    size: 0.2,
    color: "white",
  },
  {
    name: "Lisbon",
    lat: 38.736946,
    lng: -9.142685,
    size: 0.2,
    color: "white",
  },
  {
    name: "New York",
    lat: 40.73061,
    lng: -73.935242,
    size: 0.2,
    color: "white",
  },
  {
    name: "Ottawa",
    lat: 45.41117,
    lng: -75.69812,
    size: 0.2,
    color: "white",
  },
  {
    name: "Paris",
    lat: 48.864716,
    lng: 2.349014,
    size: 0.2,
    color: "white",
  },
  {
    name: "Rio de Janeiro",
    lat: -22.908333,
    lng: -43.196388,
    size: 0.2,
    color: "white",
  },
  {
    name: "San Francisco",
    lat: 37.773972,
    lng: -122.431297,
    size: 0.2,
    color: "white",
  },
  {
    name: "Singapore",
    lat: 1.29027,
    lng: 103.851959,
    size: 0.2,
    color: "white",
  },
  {
    name: "Tokyo",
    lat: 35.652832,
    lng: 139.839478,
    size: 0.2,
    color: "white",
  },
  {
    name: "Toronto",
    lat: 43.65107,
    lng: -79.347015,
    size: 0.2,
    color: "white",
  },
  {
    name: "Vancouver",
    lat: 49.246292,
    lng: -123.116226,
    size: 0.24,
    color: "white",
  },

  // {
  //   name: "ethiopia",
  //   lat: 9.145,
  //   lng: 40.489672999999996,
  //   size: 0.13,
  //   color: "white",
  // },
  // {
  //   name: "tunisia",
  //   lat: 33.886917,
  //   lng: 9.537499,
  //   size: 0.22,
  //   color: "white",
  // },
];
export default places;
